import React from "react";
import RoundButton from "./RoundButton";

interface CloseArtworkButtonProps {
  onClick: () => void;
  className?: string;
}

const CloseArtworkButton: React.FC<CloseArtworkButtonProps> = ({
  onClick,
  className,
}) => {
  return (
    <div className="select-none relative flex items-center gap-3">
      <RoundButton
        text="Sluiten"
        icon="d-close"
        onClick={onClick}
        buttonClassName={className}
      />
    </div>
  );
};

export default CloseArtworkButton;
